import { getAuthToken, onLogout } from '../actions/auth';
import store from '../store';
import {
  getAuthTokenAsClient,
  logoutAsClient
} from '../actions/connectAsClient';
import getEnvVariable from '../utils/env';

import createClient from 'openapi-fetch';
import { paths } from './types';

const customFetch = async (
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> => {
  const result = await fetch(input, init);
  let authenticationFailed = result.status === 401;
  if (
    result.status === 403 &&
    result.headers.get('content-type')?.includes('application/json')
  ) {
    const error: unknown = await result.clone().json();
    authenticationFailed =
      typeof error === 'object' &&
      error !== null &&
      (('message' in error && error.message === 'User forbidden') ||
        ('detail' in error && error.detail === 'User forbidden'));
  }
  if (authenticationFailed) {
    store.dispatch(logoutAsClient());
    store.dispatch(onLogout());
  }
  return result;
};

const getToken = async () => {
  let token = getAuthToken();
  if (!token) {
    return null;
  }

  const clientToken = getAuthTokenAsClient();
  if (clientToken) {
    token = clientToken;
  }
  return token;
};

const getClient = async () => {
  const token = await getToken();
  if (!token) {
    throw new Error('No token');
  }
  return createClient<paths>({
    baseUrl: getEnvVariable('REACT_APP_API_NEW_URL'),
    headers: { Authorization: `Token ${token}` },
    fetch: customFetch
  });
};

export default getClient;
